import {useEffect, useState} from "react";
import {ProductGroupList as List} from "../components";
import { useTranslation } from "react-i18next";
import useProductGroups from "../hooks/useProductGroups";
import ImportModal from "../components/ImportModal";
import { ProductGroupFormContainer as FormContainer } from "./";
import {useImportModal} from "../hooks/useImportModal";
import {useToaster} from "../context-providers/ToasterProvider";
import {useSelector} from "react-redux";
import {apiUrlSelector} from "../redux/selectors";
import {useDeleteModal} from "../hooks/useDeleteModal";
import {apiUrls} from "../common/apiUrls";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";

export const ProductGroupsContainer = () => {

    const {t} = useTranslation(["ProductGroupsContainer", "Buttons"]);

    const apiUrl = useSelector(apiUrlSelector);

    const { toastError } = useToaster();

    const [recordId, setRecordId] = useState(0);

    const [showRecordModal, setShowRecordModal] = useState(false);

    const { isLoading, error, data } =  useProductGroups();

    useEffect( ( ) => {
        if ( error ) {
            toastError(t("errorFetchingGroup"));
        }
    }, [error] );

    const { modal: importModal, onImportClick } = useImportModal("url fo importu d");

    const { confirmDelete, ...deleteModalProps } = useDeleteModal(apiUrls.productGroups);
    
    const handleCloseRecordModal = () => setShowRecordModal(false);

    const handleAddClick = () => {
        
        setRecordId(0);
        setShowRecordModal(true);

    };

    const handleEditClick = row => {
        setRecordId(row.id);
        setShowRecordModal(true);

    };

    const handleHistoryClick = (item) => {
        console.log("Pokazuję historię", item);
    };
    
    return (
        <>
            {showRecordModal && <FormContainer recordId={recordId}
                                               onSave={handleCloseRecordModal}
                                               onCancelClick={handleCloseRecordModal}
                                               onGetError={handleCloseRecordModal} />}

            <ImportModal {...importModal} />

            <ConfirmDeleteModal {...deleteModalProps} />
            
            <List records={data} loading={isLoading} onAddClick={handleAddClick}
                  onEditClick={handleEditClick} onDeleteClick={confirmDelete} onHistoryClick={handleHistoryClick}
                  onImportClick={onImportClick} exportHref={`${apiUrl}/${apiUrls.bom}/export"`} />
        </>
    );
};

export default ProductGroupsContainer;